<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template #activator="{ on, attrs }">
      <v-btn
        color="primary"
        dark
        v-bind="attrs"
        v-on="on"
      >
        <slot />
      </v-btn>
    </template>
    <form @submit.prevent="save">
      <v-card>
        <v-toolbar flat color="primary">
          <v-toolbar-title>Manage Role</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text v-if="availableRoles.length > 0">
          <v-list>
            <v-list-item-group v-model="form.role" mandatory>
              <v-list-item
                v-for="role in availableRoles"
                :key="role.key"
                :value="role.key"
                two-line
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ role.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ role.description }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-avatar v-if="form.role == role.key">
                  <svg
                    class="ml-2 h-5 w-5 text-green-400"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </v-list-item-avatar>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="cancel">
            Cancel
          </v-btn>
          <v-btn color="primary" type="submit">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </v-dialog>
</template>

<script>
export default {
   props: {
      team: {
         type: Object,
         required: true,
      },
      availableRoles: {
         type: Array,
         required: true,
      },
      member: {
         type: Object,
         required: true
      }
   },
   data () {
      return {
         form: this.$inertia.form({
            role: null,
         }),
         dialog: false
      }
   },
   created () {},
   methods: {
      cancel () {
         this.dialog = false
      },
      save () {
         this.form.put(this.route('team-members.update', [this.team, this.member]), {
            preserveScroll: true,
         }).then(() => {
            this.dialog = false
         })
      },
   },
}
</script>

<style>
</style>
